import { createFileRoute } from "@tanstack/react-router";

import { AdminCreditsPage } from "@/components/admin/AdminCreditsPage";

export const Route = createFileRoute("/administrator/credits")({
  head: () => ({ meta: [{ title: "Credits · GENRL Admin" }] }),
  validateSearch: (raw: Record<string, unknown>) => ({
    action: raw.action === "grant" || raw.action === "transfer" ? raw.action : undefined,
    destination_user: typeof raw.destination_user === "string" ? raw.destination_user : undefined,
    source_user: typeof raw.source_user === "string" ? raw.source_user : undefined,
  }),
  component: CreditsRoute,
});

function CreditsRoute() {
  const search = Route.useSearch();
  return (
    <AdminCreditsPage
      initialAction={search.action}
      initialDestinationUser={search.destination_user}
      initialSourceUser={search.source_user}
    />
  );
}
